import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import TransportationSettings from './guestPayment/transportation-settings';
import GuestSettings from './guestPayment/guest-settings';
import PaymentSettings from './guestPayment/payment-settings';
import TableFormFields from '../../widgets/TableFormFields';
import { signUpFormsFields, transportationArrivals } from '../../../constants';
import { getText } from '../../../../lib/utils';
import ThirdPartyOffers from './guestPayment/third-party-offers';

export default class GuestConfiguration extends Component {
    constructor(props) {
        super(props);
        this.sections = [];
    }

    registerSection = (key) => {
        return node => (this.sections[key] = node);
    }

    sectionStyleHandler = (key) => {
        return this.props.searchIndex !== undefined && this.props.searchIndex.indexOf(key) === -1
            ? { display: 'none' }
            : {};
    }

    componentDidMount() {
        if (this.props.onIndex) {
            this.sections.forEach((section, key) => {
                this.props.onIndex(getText(ReactDOM.findDOMNode(section)), [key]);
            });
        }
    }

    _handleTransportationArrivalChange = key => {
        const { setConfigBoolean } = this.props;
        const {
            ARRIVAL_TIME_NOT_REQUIRED,
            ARRIVAL_TIME_REQUIRED_IF_ENTERED,
            ARRIVAL_TIME_ALWAYS_REQUIRED
        } = transportationArrivals;

        setConfigBoolean(ARRIVAL_TIME_NOT_REQUIRED, key === ARRIVAL_TIME_NOT_REQUIRED);
        setConfigBoolean(ARRIVAL_TIME_ALWAYS_REQUIRED, key === ARRIVAL_TIME_ALWAYS_REQUIRED);
        setConfigBoolean(ARRIVAL_TIME_REQUIRED_IF_ENTERED, key === ARRIVAL_TIME_REQUIRED_IF_ENTERED);
    };

    render() {
        const { isDisabled, toggleConfigBoolean, currentConfigCopy } = this.props;

        return (
            <div className="spark-panel__content col-sm-12">
                <section
                    className="row spark-panel__content"
                    ref={this.registerSection(0)}
                    style={this.sectionStyleHandler(0)}
                >
                    <div className="col-xs-12">
                        <h4>Sign Up Forms</h4>
                        <p>
                            Select which fields should show on each form and which will be required. Tip: Don’t require
                            more than is absolutely necessary for loyalty program.
                        </p>
                        <TableFormFields isDisabled={this.props.isDisabled} fieldsData={signUpFormsFields} />
                    </div>
                </section>
                <TransportationSettings
                    registerSection={this.registerSection}
                    sectionStyleHandler={this.sectionStyleHandler}
                    isDisabled={isDisabled}
                    toggleConfigBoolean={toggleConfigBoolean}
                    currentConfigCopy={currentConfigCopy}
                    handleTransportationArrivalChange={this._handleTransportationArrivalChange}
                />
                <GuestSettings
                    registerSection={this.registerSection}
                    sectionStyleHandler={this.sectionStyleHandler}
                    isDisabled={isDisabled}
                    toggleConfigBoolean={toggleConfigBoolean}
                    currentConfigCopy={currentConfigCopy}
                />
                <PaymentSettings
                    registerSection={this.registerSection}
                    sectionStyleHandler={this.sectionStyleHandler}
                    isDisabled={isDisabled}
                    toggleConfigBoolean={toggleConfigBoolean}
                    currentConfigCopy={currentConfigCopy}
                />
                <ThirdPartyOffers
                    registerSection={this.registerSection}
                    sectionStyleHandler={this.sectionStyleHandler}
                    isDisabled={isDisabled}
                    toggleConfigBoolean={toggleConfigBoolean}
                    currentConfigCopy={currentConfigCopy}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/pages/GuestConfiguration.js